import React, { useState, useEffect } from 'react';
import '../styles/SectionHub.css';
import { IconMap } from './IconMap';

export const SectionHub = ({ parentSectionId, subSections, caseId, user_id, activeSection, setActiveSection }) => {
    return (
        <div className="section-hub case-section">
            <div className='hub-header'>
            <h3>{activeSection.name} - Section Hub</h3>
            <p className='subtext'>Quickly navigate to different sections related to {activeSection.name}.</p>
            </div>
            <div className='section-hub-wrapper' style={{ gridTemplateColumns: `repeat(${Math.min(subSections.length, 4)}, 1fr)` }}>
                {subSections.map(sub => (
                    <div
                        key={sub.id}
                        className="hub-item"
                        onClick={() => setActiveSection(sub.id)}
                        style={{ cursor: 'pointer' }}
                    >
                        {IconMap[sub.icon] ? (
                            <span className="icons-container">
                                {React.createElement(IconMap[sub.icon], { size: 26 })}
                            </span>
                        ) : (
                            <span className="icons-container default-icon">?!</span>
                        )}
                        <h4 className='hub-item-title'>{sub.name}</h4>
                        <p className='hub-item-description subtext'>{sub.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};